import { Table, TableBody, TableHead, TableRow } from '@mui/material';
import { GeneralTableBox, HeadTableCell, RowTableCell, NoDataSkeleton } from '../../../common';
import { TABLE_COLUMNS } from '../constants/lifeInsuranceConstants';
import { formatCurrency } from '../utils/lifeInsuranceUtils';

const LifeInsuranceTable = ({ data, isLoading, LoadingComponent }) => {
  if (isLoading) {
    return <LoadingComponent />;
  }

  return (
    <GeneralTableBox>
      <Table aria-label="life insurance table">
        <TableHead>
          <TableRow>
            <HeadTableCell sx={{ width: TABLE_COLUMNS.plan.width }}>Plan</HeadTableCell>
            <HeadTableCell sx={{ width: TABLE_COLUMNS.group.width }}>Grupo</HeadTableCell>
            <HeadTableCell sx={{ width: TABLE_COLUMNS.order.width }}>Orden</HeadTableCell>
            <HeadTableCell sx={{ width: TABLE_COLUMNS.subscriber.width }}>Suscriptor</HeadTableCell>
            <HeadTableCell sx={{ width: TABLE_COLUMNS.installmentDebtBalance.width }}>
              Saldo deuda cuota
            </HeadTableCell>
            <HeadTableCell sx={{ width: TABLE_COLUMNS.debtBalanceInPesos.width }}>
              Saldo deuda pesos
            </HeadTableCell>
            <HeadTableCell sx={{ width: TABLE_COLUMNS.lifeInsurance.width }}>
              Seguro de vida
            </HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.length === 0 ? (
            <NoDataSkeleton colSpan={7} />
          ) : (
            data.map((item, index) => (
              <TableRow key={index}>
                <RowTableCell>{item.plan}</RowTableCell>
                <RowTableCell>{item.group}</RowTableCell>
                <RowTableCell>{item.order}</RowTableCell>
                <RowTableCell>{item.subscriber}</RowTableCell>
                <RowTableCell>{item.installmentDebtBalance}</RowTableCell>
                <RowTableCell>{formatCurrency(item.debtBalanceInPesos)}</RowTableCell>
                <RowTableCell>{formatCurrency(item.lifeInsurance)}</RowTableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default LifeInsuranceTable;
